// ── Map UI display labels to API terminal names ─────────────────────────────
const TERMINAL_LABEL_TO_API = {
    'W or W1': 'W',
    'Y or Y1': 'Y',
    'G or F': 'G',
    'S1 or S2 or S3': 'S',
};

// ── Build API request payload from selected terminals ─────────────────────
export const buildWiringPayload = (terminals) => {
    const terminalSet = new Set(terminals);
    const groups = [
        { type: 'POWER', allowed: ['R', 'Rh', 'Rc'] },
        { type: 'COMMON', allowed: ['C', 'COM', 'X'] },
        { type: 'HEATING', allowed: ['W or W1', 'W2', 'W3', 'Aux', 'E'] },
        { type: 'COOLING', allowed: ['Y or Y1', 'Y2'] },
        { type: 'FAN', allowed: ['G or F'] },
        { type: 'HEAT_PUMP', allowed: ['O', 'B', 'O/B'] },
        { type: 'ACCESSORIES', allowed: ['Z1', 'Z2', 'dh', '*', 'U1', 'ACC+', 'K', 'L', 'T', 'S1 or S2 or S3', 'GND', 'ODT', 'Other'] },
    ];
    const result = [];
    groups.forEach(({ type, allowed }) => {
        const matched = allowed.filter(t => terminalSet.has(t));
        if (matched.length > 0) {
            result.push({ type, terminals: matched.map(t => TERMINAL_LABEL_TO_API[t] || t) });
        }
    });
    return { 'terminal-groups': result };
};

// ── Normalize API wiring-map keys to UI format ──────────────────────────────
export const normalizeWiringMap = (wiringMap) => {
    if (!wiringMap) return wiringMap;
    return wiringMap.map(row => ({
        old: row['old-terminal'] || row.old,
        'new': row['new-terminal'] || row['new'],
        action: row.action,
    }));
};

// ── Post-process wiring map for beveled (beta) display type ───────────────
export const adjustMapForDisplayType = (wiringMap, displayType) => {
    if (!wiringMap || displayType !== 'beveled') return wiringMap;
    return wiringMap.map(row => {
        if (row.action === 'connect' && row['new'] === 'RC' &&
            ['R', 'Rh', 'Rc'].includes(row.old) &&
            wiringMap.filter(r => ['R', 'Rh', 'Rc'].includes(r.old) && r.action === 'connect').length === 1) {
            return { ...row, 'new': 'RH' };
        }
        return row;
    });
};
